<template>
  <router-view />

  <el-dialog
    title=""
    v-model="inviteUrlDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :width="isPhone ? '90%' : '40%'"
    class="dia-p"
    :show-close="false"
  >
    <div style="font-size: 17px; color: #303133">确认加入</div>
    <div class="com-na-1">
      <el-icon style="color: #e6a23c; font-size: 22px; margin-right: 10px"
        ><WarningFilled /></el-icon
      >是否确认加入 <span style="font-weight: 700">{{ companyName }}</span
      >的空间?
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="cancelJoin">取消</el-button>
        <el-button @click="sureJoin" type="primary">确定</el-button>
      </span>
    </template>
  </el-dialog>
  <el-dialog
    title=""
    v-model="noticeDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    :modal-class="'right-top-dialog'"
    :width="isPhone ? '90%' : '40%'"
  >
    <div>是否确定加入</div>
    <div class="com-na">{{ companyName }}</div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="sureRead" type="primary">我知道了</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script lang="ts" setup>
import { ref, watch, computed } from 'vue';
import {
  geCompanyIvite,
  agreeEnterCompany,
  getUseMemberPrivige,
  getUserDetail,
} from '@/api/api';
import { createStore } from '@/vuex/store';
import { useRouter, useRoute } from 'vue-router';
import {
  getRouterName,
  isToken,
  rightJudgment,
  handleConsoleMenuList,
} from './utils/utils';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const router = useRouter();

const isPhone = ref(false);

const store = createStore();
const inviteUrlDialog = ref(false);
const companyName = ref<string>('');
const companyCode = ref<string>('');
const inviteParam = ref<string>('');
isPhone.value = store.state.isPhone;

const noticeDialog = ref<boolean>(false);

if (localStorage.getItem('inviteParam')) {
  if (
    localStorage.getItem('inviteParam') &&
    JSON.parse(localStorage.getItem('user')) &&
    !JSON.parse(localStorage.getItem('user')).companyCode
  ) {
    inviteParam.value = localStorage.getItem('inviteParam');
    const msg = {
      inviteParam: localStorage.getItem('inviteParam'),
    };
    geCompanyIvite(msg).then((res) => {
      if (res.success) {
        companyName.value = res.data.name;
        inviteUrlDialog.value = true;
        companyCode.value = res.data.code;
      }
    });
  }
}
function getUser() {
  if (!localStorage.getItem('token')) return;
  getUserDetail().then((res) => {
    if (res.success) {
      // store.action.setToken(res.data.token);
      store.action.updateUser(res.data.user);
    }
  });
}

if (store.state.user?.companyTabIconUrl) {
  let relIcon = document.head.querySelector("link[rel='icon']");
  relIcon.href = store.state.user.companyTabIconUrl;
}
if (store.state.user?.companyTabTitle) {
  document.title = store.state.user.companyTabTitle;
}
watch(
  () => store.state.user?.companyIconWordUrl,
  (newV) => {
    if (newV?.tabIconUrl) {
      let relIcon = document.head.querySelector("link[rel='icon']");
      relIcon.href = newV.companyTabIconUrl;
    }
    if (newV?.companyTabTitle) {
      document.title = newV.companyTabTitle;
    }
  },
  {
    deep: true,
  }
);
getUser();
function sureRead() {
  noticeDialog.value = false;
  localStorage.setItem('onReadNotice', 'read');
  getUser();
}
if (localStorage.getItem('token')) {
  getUseMemberPrivige().then((res: any) => {
    if (res.success) {
      let allowRouterName = [];
      let authorizedRoute = false;
      store.action.updataUserPrivige(res.data);
      if (JSON.parse(localStorage.getItem('user'))) {
        const userDetail = JSON.parse(localStorage.getItem('user'));
        if (userDetail.authorizedRoute) {
          authorizedRoute = userDetail.authorizedRoute;
        }
      }
      const homeMenuList = [
        { name: t('home'), routerName: 'home' },
        { name: t('chat'), routerName: 'app' },
        // { name: t('paint'), routerName: 'paintPic' },
        { name: t('template'), routerName: 'template' },
      ];

      const consoloeMenuList = handleConsoleMenuList(res.data);
      store.action.updataRouterList(consoloeMenuList);
      if (res.data.memberGrade === 'ENTERPRISE') {
        if (authorizedRoute) {
          const menuHomeList = [
            { name: t('chat'), routerName: 'app' },
            { name:  t('template'), routerName: 'template' },
          ];
          if (rightJudgment('homePage')) {
            menuHomeList.splice(0, 0, { name: t('home'), routerName: 'home' });
          }
          // if (rightJudgment('paintPage')) {
          //   menuHomeList.splice(2, 0, { name: '绘画', routerName: 'paintPic' });
          // }
          if (rightJudgment('squarePage')) {
            menuHomeList.splice(2, 0, { name: t('square'), routerName: 'square' });
          }
          // if (rightJudgment('createApp')) {
          //   menuHomeList.splice(4, 0, { name: '创建', routerName: 'console' });
          // }
          store.action.updataHomeMenuList(menuHomeList);
        } else {
          store.action.updataHomeMenuList(homeMenuList);
        }
      } else {
        store.action.updataHomeMenuList(homeMenuList);
      }
    }
  });

  // getUserPrivilege().then((res) => {
  //   sessionStorage.setItem('privilege',res.data)
  // })
}

function cancelJoin() {
  inviteUrlDialog.value = false;
  if (localStorage.getItem('inviteParam')) {
    localStorage.removeItem('inviteParam');
  }
  router.replace({
    path: '/console/agents',
  });
}

function sureJoin() {
  const msg = {
    inviteParam: inviteParam.value,
  };
  agreeEnterCompany(msg).then((res) => {
    if (res.success) {
      if (localStorage.getItem('inviteParam')) {
        localStorage.removeItem('inviteParam');
      }
      inviteUrlDialog.value = false;
      store.action.updateUserCompanyCode(companyCode.value);
      store.action.updateUserCompanyName(companyName.value);
      router.go(0);
    }
  });
}
// const handleClickA = (event) => {
//   console.log(event.target.className);
// };
// const body = document.body;
// body.addEventListener('click', handleClickA);
</script>
<style lang="less">
@import '@/less/theme.less';
:root {
  --el-color-primary: #3370ff !important;
}
.el-button.el-button--primary {
  --el-button-hover-bg-color: #5a82f5 !important;
  --el-button-hover-border-color: #5a82f5 !important;
}
.el-button.el-button--primary.is-plain {
  --el-button-border-color: #3370ff !important;
}
.el-button.el-button--primary.is-disabled {
  background-color: #8aa1f2 !important;
  border-color: #8aa1f2 !important;
}
.link-a {
  color: #4ca4ff !important;
}
#app {
  font-family: ui-sans-serif, system-ui, -apple-system, 'system-ui', 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1f1f1f;
}
.el-textarea {
  .el-textarea__inner::-webkit-scrollbar {
    width: @scrollbar-width !important;
  }
}

.el-textarea {
  .el-textarea__inner::-webkit-scrollbar-thumb {
    background-color: @scrollbar-thumb-bgc-color !important;
    border-radius: @scrollbar-thumb-radius !important;
  }
}
nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.must {
  position: relative;
}

.must {
  .el-form-item__label::before {
    content: '*';
    color: #f56c6c;
    margin-right: 4px;
    position: absolute;
    top: 0;
    left: -10px;
  }
}

.com-na {
  font-size: 20px;
  margin-top: 20px;
  width: 100%;
  text-align: center;
}
.com-na-1 {
  margin-top: 20px;
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
// .right-top-dialog {

// }
/*全局处理el-dialog的内边距过大，导致内容空白区域大*/
.el-dialog__body {
  padding: 0 !important;
  padding-left: 2rem !important;
  padding-right: 2rem !important;
  padding-bottom: 0.55rem !important;
  padding-top: 0.5rem !important;
}
// .el-tooltip__trigger {
//   color: #aaa !important;
// }
.info-filled {
  color: #606266;
}

.el-table th {
  .cell {
    color: #606266 !important;
  }
}
</style>

<style lang="less">
.dia-p {
  .el-dialog__header {
    padding: 0 !important;
  }
}
.el-dialog{
  border-radius: 10px !important;
}
.el-message-box{
  border-radius: 10px !important;
}
</style>
